const logCursorByJob = new Map();

export const getLogCursor = (jobId) => {
  if (!jobId) {
    return 0;
  }
  return logCursorByJob.get(jobId) ?? 0;
};

export const setLogCursor = (jobId, cursor) => {
  if (!jobId || cursor == null || !Number.isFinite(Number(cursor))) {
    return;
  }
  logCursorByJob.set(jobId, Number(cursor));
};

export const resetLogCursor = (jobId) => {
  if (jobId) {
    logCursorByJob.delete(jobId);
  }
};
